import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Card from './Card'
import { RoomType, UserType } from '../../utils/types'
import { scales } from '../Initial'
import { roomDoc } from '../../utils/firebase'
import { updateDoc } from 'firebase/firestore'

type CardsListProps = {
  observer: boolean
  ready: boolean
  room: RoomType
  user: UserType
}

const CardsList: React.FC<CardsListProps> = ({ observer, ready, room, user }) => {
  const cardValues: string[] = (room.scale && room.scale !== '' ? room.scale : scales[0].value)
    .replace(/\s+/g, '')
    .split(',')

  let estimate = room.users[user.id] ? room.users[user.id].estimate : undefined

  const onClick = (value: string) => {
    updateDoc(roomDoc(room.id), { ['users.' + user.id + '.estimate']: value })
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        {observer ? 'Scale' : 'Your Vote'}
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {cardValues.map(value => (
          <Grid key={value} item>
            <Card
              label={value}
              selected={!observer && estimate === value}
              disabled={observer || ready}
              onClick={() => onClick(value)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default CardsList
